import {
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { t } from "@/lib/localization";

interface StepHeaderProps {
    title: {
        keyName: string;
        defaultValue: string;
    };
    description?: {
        keyName: string;
        defaultValue: string;
    };
}

export default function StepHeader({ title, description }: StepHeaderProps) {
    return (
        <DialogHeader>
            <DialogTitle>
                {t(title.keyName, undefined, undefined)}
            </DialogTitle>
            {description && (
                <DialogDescription>
                    {t(description.keyName, undefined, undefined)}
                </DialogDescription>
            )}
        </DialogHeader>
    );
}
